"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasicLiveInfo = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Layout = require("../Layout");

var _StyledElements = require("./StyledElements");

var BasicLiveInfo = function BasicLiveInfo(_ref) {
  var liveInfo = _ref.liveInfo,
      props = (0, _objectWithoutProperties2.default)(_ref, ["liveInfo"]);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Layout.Flex, {
    flexGrow: 0
  }, _react.default.createElement(_StyledElements.HeadlineTextItem, (0, _extends2.default)({
    text: liveInfo === null || liveInfo === void 0 ? void 0 : liveInfo.scheduledAt
  }, props)), _react.default.createElement(_StyledElements.ElementsDivisor, props), _react.default.createElement(_StyledElements.HeadlineTextItem, (0, _extends2.default)({
    text: liveInfo === null || liveInfo === void 0 ? void 0 : liveInfo.duration
  }, props)), _react.default.createElement(_StyledElements.ElementsDivisor, props), _react.default.createElement(_StyledElements.HeadlineTextItem, (0, _extends2.default)({
    text: liveInfo === null || liveInfo === void 0 ? void 0 : liveInfo.language
  }, props))), _react.default.createElement(_StyledElements.LiveTitle, (0, _extends2.default)({
    text: liveInfo === null || liveInfo === void 0 ? void 0 : liveInfo.title
  }, props)));
};

exports.BasicLiveInfo = BasicLiveInfo;